// extracted by mini-css-extract-plugin
module.exports = {"content":"EditProfilePage_content__3kIj_"};